import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

function SetBedNumberSize({selectedRadio, setSelectedRadio}) {
    const { t } = useTranslation()
    // const [selectedRadio, setSelectedRadio] = useState('Normal');
    const [isDisabled, setIsDisabled] = useState(true);

    const handleRadioChange = (value) => {
        setSelectedRadio(value); // 라디오 버튼 선택 상태 업데이트
        setIsDisabled(false);
    };

    return (
        <div>
            <p className="mb-[16px] text-[18px] font-normal leading-[110%]">{t('setting.setBedNumberSize')}</p>
            <div className='flex gap-[8px]'>
                <div className="mb-[12px] rounded-[6px] p-[4px] cursor-pointer" onClick={() => handleRadioChange('NORMAL')}>                                
                    <div className="w-[408px] h-[216px] bg-[#383838] rounded-[6px] p-[4px]" style={selectedRadio === 'NORMAL' ? {backgroundColor: 'rgba(49, 130, 247, 0.20)',boxShadow: 'inset 0 0 0 1px #3182F7'} : null}>
                        <label className="custom-radio">
                            <input
                                type="radio"
                                checked={selectedRadio === 'NORMAL'}
                                onChange={() => handleRadioChange('NORMAL')}
                            />
                            <span className="mb-[6px] font-light">{t('setting.normal')}</span>
                        </label>
                        <div className='w-[400px] h-[180px] bg-black'>
                            <div className='w-[146px] h-[32px] bg-[linear-gradient(180deg,#5E5E5E_0%,#383838_100%)] text-[24px] text-white flex justify-center items-center'>1</div>                 
                        </div>
                    </div>
                </div>
                <div className="mb-[12px] rounded-[6px] p-[4px] cursor-pointer" onClick={() => handleRadioChange('LARGE')}>  
                    <div className="w-[408px] h-[216px] bg-[#383838] rounded-[6px] p-[4px]" style={selectedRadio === 'LARGE' ? {backgroundColor: 'rgba(49, 130, 247, 0.20)' ,boxShadow: 'inset 0 0 0 1px #3182F7'} : null}>
                        <label className="custom-radio">
                            <input
                                type="radio"
                                checked={selectedRadio === 'LARGE'}
                                onChange={() => handleRadioChange('LARGE')}
                            />
                            <span className="mb-[6px] font-light">{t('setting.large')}</span>
                        </label>                    
                        <div className='w-[400px] h-[180px] bg-black'>
                            <div className='w-[146px] h-[146px] bg-[linear-gradient(180deg,#5E5E5E_0%,#383838_100%)] text-[114px] text-white flex justify-center items-center'>1</div>                 
                        </div> 
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SetBedNumberSize